<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

body{
  margin: 0px;
  padding: 0px;
  /* min-width: 1200px; */
  font-family: "HarmonyOS_Sans_SC_Regular";
}

/* 页面切换淡入淡出过渡 */
.fade-enter-active{
  transition: opacity .15s ease;
}
.fade-enter{
  opacity: 0;
}
.fade-leave-active{
  transition: opacity .1s ease;
}
.fade-leave-to{
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue